module.exports = "/css/fonts/nucleo-icons.svg?0b8a30b10cbe7708d5f3a4b007c1d665";